import React from 'react'
import { Opportunities } from 'src/components/opportunities/Opportunities'
import { ReloadWrapper } from 'src/components/wrapper/reload-wrapper/ReloadWrapper'

export const OpportunitiesPage = () => {
  return (
    <ReloadWrapper>
      <div data-testid="dashboard-opportunities-page">
        <Opportunities />
      </div>
    </ReloadWrapper>
  )
}
